module.exports = __webpack_public_path__ + "media/images/service/patent_bg-6baf860614b9c6a50f5c53b56b95ac9b.png";